<template>
  <a :href="profile.link" class="profile-card text-decoration-none">

    <!-- IMAGE WRAPPER -->
    <div class="image-wrapper position-relative">

      <!-- BADGE -->
      <span
        v-if="profile.boost_name"
        class="position-absolute top-0 start-0 m-2"
      >
        <span
          v-if="profile.accountType === 'escort'"
          class="badge bg-primary"
        >
          <i class="fa fa-star me-1"></i> Featured
        </span>

        <span
          v-if="profile.accountType === 'content-creator'"
          class="badge bg-success"
        >
          <i class="fa fa-flag me-1"></i> Featured
        </span>
      </span>

      <!-- PROFILE IMAGE -->
      <img :src="profile.image" alt="profile" />
    </div>

    <!-- INFO -->
    <div class="img-info mt-2">
      <div class="name-row">
        <span class="name">
          {{ toSentenceCase(profile.name) }}, {{ profile.age }}
          <img
            v-if="profile.verified"
            :src="imgVerified"
            alt="verified"
            class="verified-icon"
          />
        </span>

        <img :src="chat" alt="chat" class="chat-icon" />
      </div>

      <div class="meta">
        <div class="meta-row">
          <img :src="location_ico" class="phone-location-ico" />
          {{ toSentenceCase(profile.location) }}
        </div>

        <div
          class="meta-row"
          v-if="profile.accountType === 'escort'"
        >
          <img :src="phone_ico" class="phone-location-ico" />

          <span v-if="$store.getters.canViewPhone">
            {{ profile.phone }}
          </span>

          <span v-else class="text-muted">
            ***********
          </span>
        </div>
      </div>
    </div>
  </a>
</template>
  
<script>
import imgVerified from "@/assets/ic_round-verified.png";
import chat from "@/assets/mynaui_chat-dots-solid.png";
import location_ico from "@/assets/tdesign_location-filled.png";
import phone_ico from "@/assets/solar_phone-bold.png";

  export default {
    name: "ProfileCard",
    props: {
      profile: {
        type: Object,
        required: true
      }
    },
    data() {
    return {
      imgVerified,
      chat,
      phone_ico,
      location_ico
    };
  },
  computed: {

  },
  methods: {
  
    toSentenceCase(text) {
        if (!text) return '';
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    },
  }
  };
  </script>
  
  <style lang="scss" scoped>
  .profile-card {
    background: #0d0d17;
    border-radius: 0px;
    overflow: hidden;
    color: #fff;
    display: block;
    color: inherit;
  }
  
  .image-wrapper {
    width: 100%;
    aspect-ratio: 1 / 1;
    min-height: 160px;
    margin: 0 auto; /* center inside grid cell */
    overflow: hidden;
    border-radius: 0px;
  }

  .image-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* crop nicely */
    display: block;
  }
  .badge {
    font-size: 10px;
    padding: 3px 5px;
    border-radius: 20px;
  }

  .img-info {
    padding: 0px;
    background: #0A070F !important;
  }
  
  .name-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;

    .name{
        color: #fff;
        text-align: left !important;
    }
  }
  
  .verified {
    color: #4da6ff;
    font-size: 12px;
  }
  .verified-icon{
    width: 14px;
    height: 14px;
  }
  .chat-icon{
    width: 14px;
    height: 14px;
  }

  .phone-location-ico {
    width: 14px;
    height: 15px;
  }

  
  .chat {
    margin-left: auto;
    color: #ff4f8b;
  }
  
  .meta {
    margin-top: 6px;
    font-size: 12px;
    //opacity: 0.75;
    color: #767475;
  }
  
  .meta-row {
    margin-top: 2px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  @media (max-width: 768px) {
    .image-wrapper {
      min-height: 140px;
    }
  }
  </style>
  
